import { createAsyncActionTypes } from 'misc/utils';

const PREFIX = 'wordlists';

export const LIST = createAsyncActionTypes(`${PREFIX}/LIST`);
export const RETRIEVE = createAsyncActionTypes(`${PREFIX}/RETRIEVE`);
export const UPDATE = createAsyncActionTypes(`${PREFIX}/UPDATE`);
export const BATCH_DELETE = createAsyncActionTypes(`${PREFIX}/BATCH_DELETE`);
export const BATCH_EXPORT_EXCEL = createAsyncActionTypes(`${PREFIX}/BATCH_EXPORT_EXCEL`);


export const UPLOAD = createAsyncActionTypes(`${PREFIX}/UPLOAD`);
export const EXPORT_EXCEL = createAsyncActionTypes(`${PREFIX}/EXPORT_EXCEL`);
export const AUTOCOMPLETE = createAsyncActionTypes(`${PREFIX}/AUTOCOMPLETE`);